import { commonPaginationOptions, mergeGridOpts } from 'utils/agGrid/options';

const clearingAccountsOpts = mergeGridOpts(commonPaginationOptions, {
  rowStyle: { cursor: 'pointer' },
  defaultColDef: {
    wrapText: true,
    autoHeight: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
  },
});

export default clearingAccountsOpts;
